<template>
  <pi-activity-1 v-if="campaignType == 1" :details="details"></pi-activity-1>
  <pi-activity-2 v-else-if="campaignType == 2" :details="details"></pi-activity-2>
  <pi-activity-5 v-else-if="campaignType == 5" :details="details" :staList="staList"></pi-activity-5>
  <pi-activity-6 v-else-if="campaignType == 6" :details="details"></pi-activity-6>
</template>
<script>
import {getCampaignDetail,getPriceDetails, alreadyExistSta} from '@/common/api/index'
import activity1 from './components/activity-1.vue';
import activity2 from './components/activity-2.vue';
// import activity3 from './components/activity-3.vue';
import activity5 from './components/activity-5.vue';
import activity6 from './components/activity-6.vue';
export default {
  name: 'pi-activity-details',
  components: {
    [activity1.name]: activity1,
    [activity2.name]: activity2,
    [activity5.name]: activity5,
    [activity6.name]: activity6,
  },
  data(){
    return {
      details: {},
      campaignPkId: '',
      campaignType: '',
      staList: []
    }
  },
  methods: {
    getCampaignDetail(){
      getCampaignDetail({campaignPkId: this.campaignPkId}).then(response => {
        if ( response.status == this.$config.ajaxStatus) {
          this.details = response.data[0];
        }
      })
    },
    getPriceDetails(){
      getPriceDetails({campaignPkId: this.campaignPkId}).then(response => {
        if ( response.status == this.$config.ajaxStatus) {
          this.details = response.data[0];
        }
      })
      this.alreadyExistSta();
    },
    alreadyExistSta(){
      alreadyExistSta({objectPkId: this.campaignPkId,objectType: 4}).then(response => {
        if ( response.status == this.$config.ajaxStatus) {
          if(response.data[0]){
            let staList = response.data[0].staList;
            let nameList = [];
            staList.map(item=>{
              nameList.push(item.staName)
            })
            this.staList = nameList;
          }
        }
      })
    }
  },
  mounted() {
    let query = this.$route.query;
    this.campaignPkId = query.campaignPkId;
    this.campaignType = query.campaignType;
    if(this.campaignType == 5){
      this.getPriceDetails(); 
    }else{
      this.getCampaignDetail();
    }
  },
}
</script>
<style lang="less">
  .activity-details{
    background-color: #C0ECCB;
    .activity-header-info{
      height: 3.06rem;
      background-image: url('../../assets/image/activity-bg.png');
      background-size: 100% 100%;
      color: #fff;
      .activity-time{
        padding: 0.2rem;
        font-size: 0.18rem;
        line-height: 0.25rem;
      }
      .activity-title{
        text-align: center;
        margin-top: 0.45rem;
        font-size: 0.6rem;
        line-height: 0.84rem;
      }
      .activity-text{
        margin-top: 0.02rem;
        font-size: 0.28rem;
        line-height: 0.4rem;
        color: #F2F7B0;
        text-align: center;
      }
    }
    .details-block{
      padding: 0 0.35rem 0.68rem 0.35rem;
    }
    .activity-content{
      margin-top: 0.82rem;
      position: relative;
      background-color: #fff;
      border-radius: 0.2rem;
      padding: 0.7rem 0.3rem 0.5rem 0.3rem ;
      font-size: 0.28rem;
      line-height: 0.4rem;
      color: #666666;
      .activity-icon{
        position: absolute;
        top: -0.42rem;
        left: 50%;
        transform: translateX(-50%);
        background-image: url('../../assets/image/activity-title.png');
        background-size: 100% 100%;
        width: 3.73rem;
        height: 0.84rem;
        font-size: 0.36rem;
        line-height: 0.54rem;
        padding-top: 0.09rem;
        text-align: center;
        box-sizing: border-box;
        color: #fff;
      }
    }
    .activity-content:first-child{
      margin-top: 0.92rem;
      padding-top: 0.5rem;
    }
    .activity-type{
      text-align: center;
      color: #28AB6D;
      span{
        margin-left: 0.3rem;
      }
      span:first-child{
        margin-left: 0;
      }
    }
    .activity-condition{
      .condition-item{
        margin-top: 0.3rem;
        .condition-title{
          position: relative;
          padding-left: 1.48rem;
          line-height: 0.62rem;
          color: #28AB6D;
          .title{
            position: absolute;
            left: -0.3rem;
            top: 0;
            height: 0.62rem;
            width: 1.52rem;
            background-color: #28AB6D;
            border-radius: 0px 1rem 1rem 0px;
            color: #fff;
            text-align: center;
          }
        }
        .condition-info{
          display: flex;
          margin-top: 0.2rem;
          .info-left{
            width: 2.16rem;
            .block{
              padding: 0 0.12rem;
              background-color: #FFA244;
              border-radius: 0.02rem;
              color: #fff;
              display: inline-block;
              vertical-align: top;
              margin-left: 0.12rem;
            }
          }
          .info-right{
            flex: 1;
            .info-item{
              display: flex;
              .full{
                width: 1.67rem;
              }
              .flex{
                flex:1;
              }
            }
          }
          .mg-top,.info-item{
            margin-top: 0.2rem;
          }
          .info-item:first-child{
            margin-top: 0;
          }
        }
      }
      .condition-item:first-child{
        margin-top: 0;
      }
    }
    .p-title{
      color: #28AB6D;
      margin-bottom: 0.2rem;
    }
  }
</style>